import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'updated_at', label: 'updated_at' },
  { id: 'events_per_day', label: 'events_per_day' },
  { id: 'score_spam', label: 'score_spam' },
  { id: 'score_not_ok', label: 'score_not_ok' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'User IDs' },
  { id: 'ai_labels2', label: 'AI Labels' },
  { id: 'is_null', label: 'Is Null' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const FarcasterUsersQuery = () => {
  return (
    <QueryModes
      source="farcaster-users"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default FarcasterUsersQuery;
